export const filterOption = (input: string, option?: { [name: string]: string }) =>
	String(option?.label ?? '')
		.toLowerCase()
		.includes(input.toLowerCase());
